import { FarmerContactDetails } from '@features/dashboard/farmerDashboard/farmerUserCard/contactDetails';
import { FarmerUserCardWrapper } from '@features/dashboard/farmerDashboard/farmerUserCard/farmerCardWrapper';
import { FarmerCommunication } from '@features/dashboard/farmerDashboard/farmerUserCard/farmerCommunication';
import { FarmerOffer } from '@features/dashboard/farmerDashboard/farmerUserCard/farmerOffer';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { useUsersStore } from 'services/users';
import './styles.css';

export const FarmerPage = () => {
	const { user } = useUsersStore();

	useAppbarTitle('myProfile');

	return (
		<div className={`card-wrapper`}>
			<FarmerUserCardWrapper firstName={user?.first_name || ''} lastName={user?.last_name || ''} />
			<div className="flex gap-[20px] mt-[20px] max-md:flex-col">
				<div className="flex flex-col gap-[20px] pb-5 w-full">
					<FarmerContactDetails phone={user?.phone || ''} email={user?.email || ''} />
					<FarmerCommunication />
					<FarmerOffer />
				</div>
			</div>
		</div>
	);
};
